<template>
  <div class="vx-card card-page mb-4 flex flex-col">
    <div v-if="cardTitle" class="page-card-title">
      <div class="flex flex-row flex-no-wrap justify-between items-center">
        <div>
          <h2>{{ cardTitle }}</h2>
          <p v-if="cardSubtitle">{{ cardSubtitle }}</p>
        </div>
        <vs-switch
            v-if="switchModel !== null"
            color="success"
            v-model="switchModel"
            disabled="true"
            class="opacity-100"
        >
          <span slot="on">Active</span>
          <span slot="off">Inactive</span>
        </vs-switch>

        <div class="flex" v-if="switchModels !== null && switchModels.length">
          <vs-switch
              v-for="(switchModel, index) in switchModels"
              :key="index"
              color="success"
              v-model="switchModel.model"
              disabled="true"
              class="opacity-100 ml-4"
          >
            <span slot="on">{{ switchModel.activeLabel }}</span>
            <span slot="off">{{ switchModel.inactiveLabel }}</span>
          </vs-switch>
        </div>
      </div>
    </div>

    <slot></slot>

  </div>
</template>

<script>

export default {
  name: "CardPage",
  props: {
    cardTitle: {
      type: String,
    },
    cardSubtitle: {
      type: String,
    },
    switchModel: {
      default: null,
    },
    switchModels: {
      type: Array,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
  .page-card-title {
    border-bottom: 1px solid #d5dae075;
    padding: 1rem;

    > div {
      min-height: 30px;
    }
  }
</style>
